import {
  Flex,
  Image,
  useDisclosure,
  IconButton,
  Collapse,
} from "@chakra-ui/react";
import React, { useEffect, useContext } from "react";
import { isBrowser } from "react-device-detect";
import { IoMenu, IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import { UserContext } from "../../../contexts/UserContext";
import sylaLogo from "../../../images/SylaLogoLight.svg";
import { Device } from "../../../types/user/device";
import { NavbarLinks } from "./NavbarLinks";

export const Navbar = () => {
  const { userDevice } = useContext(UserContext);
  const { isOpen, onToggle, onClose } = useDisclosure();
  useEffect(() => {
    onClose();
  }, [userDevice === Device.Mobile, onClose]);

  return (
    <Flex
      bgColor="black.1000"
      maxH="100vh"
      overflowY="auto"
      minW="200px"
      px="30px"
      shrink={0}
      direction="column"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Link to="/dashboard">
          <Image src={sylaLogo} alt="Syla Logo" w="80px" m="20px 0 20px 2px" />
        </Link>
        {(userDevice === Device.Mobile || !isBrowser) && (
          <IconButton
            aria-label="Navbar button"
            bgColor="transparent"
            _hover={{ bgColor: "transparent" }}
            _active={{ bgColor: "transparent" }}
            onClick={() => onToggle()}
          >
            {isOpen ? (
              <IoClose color="#fff" size="2rem" />
            ) : (
              <IoMenu color="#fff" size="2rem" />
            )}
          </IconButton>
        )}
      </Flex>

      {userDevice === Device.Mobile || !isBrowser ? (
        <Collapse in={isOpen} endingHeight="100vh">
          <NavbarLinks onClose={() => onClose()} />
        </Collapse>
      ) : (
        <NavbarLinks onClose={() => undefined} />
      )}
    </Flex>
  );
};
